<template>
  <div v-if="chapter">
    <h1>{{ $t("storyHub.chapterList.details") }}</h1>
    <h2 v-if="chapter.name != ''" style="overflow-wrap: break-word;">{{ chapter.name }}</h2>
    <h2 v-else>{{ $t('chapter.noTitle') }}</h2>
    <v-sheet color="secondaryBackground" class="rounded-xl pa-3">
      <EditChapterPreview :chapter="chapter" />
      <v-expansion-panels multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('chapter.location') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <ChapterLocation :chapter="chapter" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t('storyHub.chapterList.connectionsAndRequirements') }}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pa-0">
            <ChapterConnections :chapters="chapters" :chapter="chapter" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <DeleteChapter v-if="!startChapter" :chapter="chapter" />
    </v-sheet>
  </div>
</template>
<script>
import EditChapterPreview from './EditChapterPreview'
import ChapterConnections from './ChapterConnections/ChapterConnections'
import DeleteChapter from './DeleteChapter'
import ChapterLocation from './ChapterLocation/ChapterLocation'
export default {
  components: {
    EditChapterPreview,
    ChapterConnections,
    DeleteChapter,
    ChapterLocation,
  },
  props: {
    chapter: Object,
    chapters: Array,
    startChapter: Boolean,
  },
};
</script>